

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), ["\n  ", h('path', {"fill":"currentColor","fill-rule":"nonzero","d":"M11 .25c6.05 0 6.75 3.85 6.75 6.75l.001 1.342c3.024.368 3.999 1.896 3.999 5.658v2c0 4.41-1.34 5.75-5.75 5.75H6C1.59 21.75.25 20.41.25 16v-2c0-3.762.975-5.29 4-5.658V7c0-2.9.7-6.75 6.75-6.75Zm5.23 9.501L6 9.75c-3.502 0-4.22.65-4.249 4.021L1.75 16c0 3.57.67 4.25 4.25 4.25h10c3.58 0 4.25-.68 4.25-4.25v-2c0-3.492-.641-4.22-4.02-4.249ZM11 11.75c1.79 0 3.25 1.46 3.25 3.25s-1.46 3.25-3.25 3.25S7.75 16.79 7.75 15s1.46-3.25 3.25-3.25Zm0 1.5c-.96 0-1.75.79-1.75 1.75s.79 1.75 1.75 1.75 1.75-.79 1.75-1.75-.79-1.75-1.75-1.75Zm0-11.5c-4.36 0-5.25 2.1-5.25 5.25v1.251h10.5V7c0-3.15-.89-5.25-5.25-5.25Z"}, []), "\n"]);
};

        